var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"text-capitalize",attrs:{"disabled":_vm.disabled,"color":"success  white--text"}},[_vm._v(" "+_vm._s(_vm.$t("save"))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }